import { render, staticRenderFns } from "./RequestDescriptionField.vue?vue&type=template&id=fb274a0a&"
import script from "./RequestDescriptionField.vue?vue&type=script&lang=js&"
export * from "./RequestDescriptionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QSelect} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QSelect}, component.options.components || {})
